// extracted by mini-css-extract-plugin
export default {"divParent":"style_divParent__hCatx"};